import { Component, OnInit } from "@angular/core";
import { UtilMasks } from "src/app/utils/util-masks";
import { FormGroup, FormControl } from "@angular/forms";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import { LaudoUnionService } from "src/app/services/http/laudo-union.service";
import { Router, ActivatedRoute } from "@angular/router";
import { LoginService } from "src/app/services/login.service";
import { first } from "rxjs/operators";
import { Usuario } from "src/app/models/usuario-login";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalEditarVistoriadorComponent } from "../modal-editar-vistoriador/modal-editar-vistoriador.component";
import { ModalMsgService } from "src/app/services/modal-msg.service";

@Component({
  selector: "app-list-laudo-union",
  templateUrl: "./list-laudo-union.component.html",
  styleUrls: ["./list-laudo-union.component.scss"],
})
export class ListLaudoUnionComponent implements OnInit {
  usuario: Usuario;
  tableLoading: boolean = false;
  listaResultado = [];
  total: number = 0;
  pesquisaDataInicio: any;
  pesquisaDataFim: any;

  laudoVisualizacao = null;

  masks = {
    data: { mask: UtilMasks.dataBr, guide: false },
    placa: { mask: UtilMasks.placa, guide: false },
  };

  form = new FormGroup({
    id: new FormControl(""),
    placa: new FormControl(""),
    tipolaudo: new FormControl(""),
    status: new FormControl(""),
    cliente: new FormControl(""),
    unidade: new FormControl(""),
    dataRealizacaoInicio: new FormControl(""),
    dataRealizacaoFim: new FormControl(""),
    parecertecnico: new FormControl(""),
  });

  params = {
    filter: {
      chassi: "",
      cliente: "",
      dataFim: new Date(),
      dataInicio: new Date(),
      id: "",
      placa: "",
      status: "",
      tipoLaudo: "",
      unidade: "",
      parecertecnico: "",
    },
    sorting: {
      id: "desc",
      nometipolaudo: "",
      nomecliente: "",
      nomeunidade: "",
      nomeusuario: "",
      placa: "",
      datacriacao: "",
      dataultimaatualizacao: "",
      status: "",
      parecertecnico: "",
    },
    data: new Date(),
    per_page: 10,
    page: 1,
  };

  listaTipoLaudo = [{ nome: "Selecione", id: "" }];
  listaClientes = [{ nomefantasia: "Selecione", id: "" }];
  listaUnidades = [{ nomefantasia: "Selecione", id: "" }];

  parecerTecnico = [
    {
      id: "",
      nome: "Selecione",
    },
    {
      id: "1",
      nome: "APROVADO / CONFORME",
    },
    {
      id: "2",
      nome: "APROVADO COM RESTRIÇÕES / CONFORME COM RESTRIÇÕES / COM RESTRIÇÃO",
    },
    {
      id: "3",
      nome: "APROVADO COM APONTAMENTO / CONFORME COM APONTAMENTO / COM APONTAMENTOS",
    },
    {
      id: "4",
      nome: "SEM APONTAMENTO / COM APONTAMENTO",
    },
    {
      id: "5",
      nome: "PENDENTE",
    },
  ];

  constructor(
    private loginService: LoginService,
    private laudoUnionService: LaudoUnionService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private modalMsgService: ModalMsgService,
  ) {
    let statusLaudo = this.route.snapshot.queryParams;
    if (statusLaudo && statusLaudo != null) {
      this.params.filter.status = <any>statusLaudo.status || "";
    }
    this.loginService
      .getLogIn()
      .pipe(first())
      .subscribe((u) => (this.usuario = u));
    this.laudoUnionService
      .getListaUnidades()
      .then((r) => (this.listaUnidades = this.listaUnidades.concat(r)));
    this.laudoUnionService
      .getListaClientes()
      .then((r) => (this.listaClientes = this.listaClientes.concat(r)));
    this.laudoUnionService
      .getListaTipoLaudo()
      .then((r) => (this.listaTipoLaudo = this.listaTipoLaudo.concat(r)));
  }

  ngOnInit() {
    this.params.filter.dataInicio.setDate(1);

    this.updateResult();

    this.form.valueChanges
      .pipe(distinctUntilChanged(), debounceTime(800))
      .subscribe((r) => {
        this.params.filter = { ...this.params.filter, ...r };
        // Verifica se existe ID, caso exista, transforma em String
        if (this.params.filter.id) {
          let id = this.params.filter.id.toString();
          this.params.filter.id = id;
        }
        this.updateResult();
      });
  }

  changeOrder() {
    this.updateResult();
  }

  setPageSize(size) {
    this.params.per_page = size;
    this.updateResult();
  }

  nextPage() {
    this.updateResult();
  }

  updateResult() {
    let dataUpdate = this.params.data;

    let param = {
      ...this.params,
      filter: {
        ...this.params.filter,
        dataFim: this.params.filter.dataFim.getTime(),
        dataInicio: this.params.filter.dataInicio.getTime(),
      },
    };

    this.laudoUnionService.getListaLaudos(param).then((r) => {
      if (dataUpdate == this.params.data) {
        this.total = r.total || 0;
        this.listaResultado = r.lista || [];
      }
    });
  }

  setSituacaoLaudo(situacaoLaudo) {
    this.params.filter.status = situacaoLaudo;
    this.updateResult();
  }

  setDataInicio(date, update = true) {
    date = this.params.filter.dataInicio.getTime();
    this.pesquisaDataInicio = date;
    if (update) this.updateResult();
  }

  setDataFim(date, update = true) {
    date = this.params.filter.dataFim.getTime();
    this.pesquisaDataFim = date;
    if (update) this.updateResult();
  }

  editarLaudo(id) {
    this.router.navigate(["laudo", "configuracao", "editar", id]);
  }

  editarVistoriador(id, laudoId){

      const modalRef = this.modalService.open(ModalEditarVistoriadorComponent, { centered: true });
      modalRef.componentInstance.cabecalho = 'Alterar vistoriador responsavel';
      modalRef.componentInstance.id = id;
      modalRef.result.then(vistoriador => {
        if (vistoriador) {
          let json = {
            vistoriadorId: vistoriador,
            laudoId: laudoId
          }
          this.laudoUnionService.salvarNovoVistoriador(json)
            .then((r) => {window.location.reload()})
            .catch(e => this.modalMsgService.openDialog('Erro ao atualizar vistoriador', '', 'danger'));
        }
      }).catch(e => this.modalMsgService.openDialog('Erro ao atualizar vistoriador',
        '', 'danger'));
  }

  cancelarAgendamento(laudoId, placa){
    this.modalMsgService.openDialogQuestion('ATENÇÃO !!!', 'Deseja realmente cancelar este agendamento ?').then(
      resposta => {
        if(resposta == 'ok'){
          this.laudoUnionService.cancelarAgendamento(laudoId, placa).then((r) =>{window.location.reload()})
          .catch(e => this.modalMsgService.openDialog('Erro ao cancelar agendamento', 'Caso problema persistir, favor entrar contato com o surpote.', 'danger'));
        }
      }).catch(e => this.modalMsgService.openDialog('Erro ao cancelar agendamento', 'Caso problema persistir, favor entrar contato com o surpote.', 'danger'));
  }

  downloadExcel() {
    let param = {
      ...this.params,
      filter: {
        ...this.params.filter,
        dataFim: this.params.filter.dataFim.getTime(),
        dataInicio: this.params.filter.dataInicio.getTime(),
      },
    };
    this.laudoUnionService.downloadExcel(param).then(
      (data) => {
        let file = new FileReader();
        let dataExcel = new Date();
        let strData =
          dataExcel.getDate() +
          "-" +
          (dataExcel.getMonth() + 1) +
          "-" +
          dataExcel.getFullYear();
        file.onload = () => {
          const nav = (window.navigator as any);
          if (nav && nav.msSaveOrOpenBlob) {
            nav.msSaveOrOpenBlob(file);
          } else {
            const link = document.createElement("a") as HTMLAnchorElement;
            link.href = file.result as string;
            link.download = "Laudos " + strData + ".xlsx";
            link.addEventListener("click", () => {
              document.body.removeChild(link);
              window.URL.revokeObjectURL(file.result as string);
            });
            document.body.appendChild(link);
            link.click();
          }
        };

        file.readAsDataURL(data);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  openSyncSuccess(modalSyncSuccess, laudo) {
    this.laudoVisualizacao = laudo;
    this.laudoVisualizacao.titulo = laudo.integradorintegracao.toLowerCase();
    this.modalService
      .open(modalSyncSuccess, { ariaLabelledBy: "modal-basic-title" })
      .result.then(
        (result) => {
          // this.closeResult = `Closed with: ${result}`;
          console.info("reenviar");
        },
        (reason) => {
          // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  openSyncError(modalSyncError, laudo) {
    this.laudoVisualizacao = laudo;
    this.laudoVisualizacao.titulo = laudo.integradorintegracao.toLowerCase();
    this.modalService
      .open(modalSyncError, { ariaLabelledBy: "modal-basic-title" })
      .result.then(
        (result) => {
          if (result) {
            this.laudoUnionService
              .atualizaIntegracao(laudo.tokenlaudo, laudo.idintegracao)
              .then(this.updateResult);
          }
        },
        (reason) => {
          // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  openModalHG(modalHG, laudo) {
    this.laudoVisualizacao = laudo;
    this.modalService.open(modalHG, { ariaLabelledBy: "modal-basic-title" });
  }
}
